import styled from 'styled-components';
import theme from '../../const/theme';

export const AboutContainer = styled.div`
    max-width: 1270px;
    width: 100%;
    background-color: ${theme.COLORS.GRAY};
    border-radius: 50px;
    margin: 25px auto;
    padding: 3em;
    margin-top: 75px;

    @media screen and (max-width: 768px){
        padding: 0;
        max-width: 100;

    }
`

export const AboutTextWrapper = styled.div`
    text-align: center;
`

export const AboutWrapper = styled.div`
    width: 100%;
`

export const AboutRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 90px 30px;
    @media screen and (max-width: 768px){
        flex-direction: column;
        justify-content: center;
        padding: 0;
        align-items: center;
    }
`


export const AboutCard = styled.div`
    background-color: ${({white})=> (white ? "#FFF" : "tranparent")};

    max-width: 31%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 0;
    margin: 0;
    height: 300px;
    border-radius: 10px;
    transition: all 0.2s ease-in-out;
    box-sizing: content-box;
    box-shadow: 0px 0px 20px 1px rgba(0,0,200,0.3);
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }

    @media screen and (max-width: 768px){
        max-width: 90%;
        width: 100%;
        margin-bottom: 20px;

    }
    
`

export const AboutIcon = styled.img`
    height: 100px;
    margin: 15px 0px;

`

export const AboutH1 = styled.h1`
    font-family: 'Roboto-Regular', sans-serif;     
    font-size: 2.7rem;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    margin-bottom: 25px;
    @media screen and (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 30px; 
        text-align: center;
        padding-top: 30px;

    }
`
export const AboutH2 = styled.h2`
    font-family: 'Roboto-Regular', sans-serif;     
    font-size: 2.7rem;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    margin-bottom: 30px;
    margin-top: 45px;
    @media screen and (max-width: 768px){
        font-size: 1.5rem;
        margin-bottom: 30px; 
        text-align: center;
        padding-top: 30px;

    }
`

export const AboutP = styled.p`
    font-family: 'Roboto-Regular', sans-serif;     
    font-size: .9rem;
    font-weight: 500;
    line-height: 1.15rem;
    padding: 0px 35px;
    text-align: justify;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#777')};
`
export const AboutText = styled.p`
    font-family: 'Segoe-ui';     
    font-size: 1.15rem;
    font-weight: 500;
    line-height: 1.5rem;
    padding: 0px 20px;
    padding-top: 30px;
    text-align:left;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#777')};

    @media screen and (max-width: 768px){
        font-size: 1rem;

    }
`
